import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=56e8aa9a&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
import style0 from "./FormInput.scss?vue&type=style&index=0&id=56e8aa9a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8aa9a",
  null
  
)

export default component.exports